import type { Product, Promotion } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { useMemo } from 'react'
// import ButtonLink from '../ButtonLink'
import { ProductCardType } from '@/constants'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'
import ProductCard from '../ProductCard'

interface Props {
  products: Array<Product>
  recommendCategories: Array<Promotion>
  categoryActive: Promotion | null
  setCategoryActive: (e: Promotion) => void
  title: string
  subTitle: string
}

const Recommend = ({
  products,
  recommendCategories,
  categoryActive,
  setCategoryActive,
  title = '',
  subTitle = '',
}: Props) => {
  const handFilter = (e: Promotion) => {
    if (!categoryActive) {
      setCategoryActive(e)
    } else {
      setCategoryActive(e)
    }
  }
  const t = useTranslations('Common')
  const categories = useMemo(() => {
    return recommendCategories?.map((item, index) => (
      <div
        key={index}
        className={`${
          categoryActive?._id === item._id ? 'order-0' : 'order-' + item._id
        }`}
      >
        <div
          className={`flex h-[110px] w-44 flex-wrap content-center items-center justify-center outline-none transition duration-300 ${
            categoryActive?._id == item?._id
              ? ' rounded-lg border border-dark-900 bg-yellow-100 font-bold uppercase'
              : ''
          }`}
          onClick={() => handFilter(item)}
        >
          <ImageOptimize
            alt={getTranslate(item.name)}
            src={
              categoryActive?._id == item._id
                ? item.highlightIcon || ''
                : item.icon || ''
            }
            className='mb-1 aspect-square h-auto w-auto max-w-[36px]'
            loading='lazy'
          />
          <p className='w-full text-center text-base text-dark-400'>
            {getTranslate(item.name)}
          </p>
        </div>
      </div>
    ))
  }, [categoryActive, recommendCategories])

  const productRender = useMemo(() => {
    return (
      products.length > 0 &&
      products.map((e: Product) => (
        <ProductCard
          key={e._id}
          product={e}
          className=''
          type={ProductCardType.RECOMMENDED}
        />
      ))
    )
  }, [products])
  return (
    <>
      {categoryActive && (
        <section className='recommend mb-[40px]'>
          <div className='recommend--header relative mb-5 flex flex-wrap justify-center'>
            <h2 className='block w-full text-center text-HeadlineLarge font-bold leading-normal text-dark-400'>
              {title}
            </h2>
            <p className='subTitle text-center text-sm font-normal uppercase leading-tight text-gray-500'>
              {subTitle}
            </p>
            {categoryActive.viewMoreLink && (
              <Link
                href={categoryActive.viewMoreLink}
                className='btnMore absolute right-0 top-[50%] flex h-[36px] translate-y-[-50%] items-center justify-center gap-1 border-[0.5px] border-grey-900 bg-white px-2 text-mainBody text-dark-900'
              >
                <span className='uppercase'>{t('seeAll')}</span>
                <img
                  src='/assets/icons/arrow/arrow-right-long.svg'
                  alt='Xem thêm'
                />
              </Link>
            )}
          </div>
          <div className='recommend--filter mb-[30px]'>
            <div className='overflowX flex w-full items-center justify-start overflow-x-auto rounded-lg bg-gray-100'>
              {categories}
            </div>
          </div>
          <div className='recommend--content grid grid-cols-4 gap-[32px]'>
            {productRender}
          </div>
        </section>
      )}
    </>
  )
}
export default Recommend
